import { render, staticRenderFns } from "./estimatorSparepartDetail.vue?vue&type=template&id=5fdfb2dd&scoped=true"
import script from "./estimatorSparepartDetail.vue?vue&type=script&lang=js"
export * from "./estimatorSparepartDetail.vue?vue&type=script&lang=js"
import style0 from "./estimatorSparepartDetail.vue?vue&type=style&index=0&id=5fdfb2dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdfb2dd",
  null
  
)

export default component.exports